import React, { useContext } from "react";
import { MdPerson } from "react-icons/md";

import {AuthContext} from '../services/Session/Context'

const UserProfileCard = () => {
  const { user } = useContext(AuthContext)

  return (
    <form className="shadow-md">
      <div className="p-4 bg-gray-100 border-t-2 border-blue-400 rounded-lg bg-opacity-5">
        <div className="max-w-sm mx-auto md:w-full md:mx-0">
          <div className="inline-flex items-center space-x-4">
            <MdPerson className="bg-blue-200 rounded-full h-10 w-10 p-2" color="white" />
            <h1 className="text-gray-600">
              Mon profil
            </h1>
          </div>
        </div>
      </div>
      <div className="space-y-6 bg-white">
        <div className="items-center w-full p-4 space-y-4 text-gray-500 md:inline-flex md:space-y-0">
          <h2 className="max-w-sm mx-auto md:w-1/3">
            Mes informations
          </h2>
          <div className="max-w-sm mx-auto space-y-5 md:w-2/3">
            <div>
              <div className=" relative ">
                <input 
                  type="text"
                  className=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                  placeholder="Nom"
                  disabled
                  value={user.lastName}
                />
              </div>
            </div>
            <div>
              <div className=" relative ">
                <input
                  type="text"
                  className=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                  placeholder="Prénom"
                  disabled
                  value={user.firstName}
                />
              </div>
            </div>
            <div>
              <div className=" relative ">
                <input
                  type="email"
                  className=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                  placeholder="Email"
                  disabled
                  value={user.email}
                />
              </div>
            </div>
            <button
              type='button'
              onClick={(e) => {
                e.preventDefault()
                window.location.href = `mailto:${process.env.REACT_APP_MAIL}?subject=[Autolini] Modification de compte&body=Expliquez ici votre demande de modification de vos informations personnelles. Merci d'indiquer l'adresse email du compte concerné.`
              }}
              className="py-2 px-4 bg-green-600 hover:bg-green-700 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg"
            >
              Demander une modification
            </button>
          </div>
        </div>
        {/*<hr/>
        {/*<div className="items-center w-full p-8 space-y-4 text-gray-500 md:inline-flex md:space-y-0">
          <h2 className="mr-6">
            Réinitialiser mon mot de passe
          </h2>
          <button type="button" className="py-2 px-4 bg-pink-600 hover:bg-pink-700 focus:ring-pink-500 focus:ring-offset-pink-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
            Réinitialiser
          </button>
        </div>
        <hr/>
        {/*<div className="w-full px-4 pb-4 ml-auto text-gray-500 md:w-1/3">
          <button type="submit" className="py-2 px-4  bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
            Enregistrer
          </button>
        </div>*/}
      </div>
    </form>
  );
}

export default UserProfileCard
